/* global gtag */
'use strict';

import Actions from './actions';
import Alert from '../../../components/alert.jsx';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../components/form/text-control.jsx';
import TextareaControl from '../../../components/form/textarea-control.jsx';
import PropTypes from 'prop-types';

class Form extends React.Component {
    constructor(props) {

        super(props);

        this.input = {};
        this.state = { mounted: false, ...Store.getState()};
    }

    componentDidMount() {

        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

        if (this.input.name) {
            this.input.name.focus();
        }

        this.setState( { mounted: true });
    }

    componentWillUnmount() {

        this.unsubscribeStore();
    }

    onStoreChange() {

        this.setState(Store.getState());
    }

    handleReset(event) {
        event.preventDefault();
        event.stopPropagation();
        Actions.reset();
    }
    handleSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        let sent = false;
        const send = () => {
            if ( !sent ) {
                sent = true;
                Actions.sendMessage({
                    name: this.input.name.value(),
                    email: this.input.email.value(),
                    message: this.input.message.value(),
                    opt_in_at_sign_up: this.input.opt_in.checked
                });
            }
        };

        if ( typeof gtag === 'function' ){
            setTimeout(send, 1000);
            gtag('event', 'contact_us_form', { 'event_callback': send });


        } else {
            send();
        }
    }

    render() {

        let alert = [];

        if (this.state.success) {
            alert = (
                <h4 style={{ marginTop: '25px' }} className="text-success">Thank You!  We'll get back to you ASAP!</h4>
            );
        }
        else if (this.state.error) {
            alert = <Alert
                type="danger"
                message='There was a problem.'
            />;
        }

        let formElements;

        if (!this.state.success) {
            formElements = <form onSubmit={this.handleSubmit.bind(this)}>
                {alert}
                <fieldset>
                    <TextControl
                        ref={(c) => (this.input.name = c)}
                        name="name"
                        label="Your name"
                        hasError={this.state.hasError.name}
                        help={this.state.help.name}
                        disabled={this.state.loading}
                    />
                    <TextControl
                        ref={(c) => (this.input.email = c)}
                        name="email"
                        label="Your email"
                        hasError={this.state.hasError.email}
                        help={this.state.help.email}
                        disabled={this.state.loading}
                    />
                    <TextareaControl
                        ref={(c) => (this.input.message = c)}
                        name="message"
                        label="Message"
                        rows="5"
                        hasError={this.state.hasError.message}
                        help={this.state.help.message}
                        disabled={this.state.loading}
                    />
                    <div className="pc-checkbox form-group">
                        <input ref={(c) => (this.input.opt_in = c)} id='checkbox' type='checkbox' />
                        <label htmlFor="checkbox">I would like to receive marketing and promotion emails from PrioraCare</label>
                    </div>
                    <ControlGroup hideLabel={true} hideHelp={true}>
                        <Button
                            type="submit"
                            inputClasses={{ 'btn-primary': true }}
                            disabled={this.state.loading || !this.state.mounted} >

                        Send message
                            <Spinner space="left" show={this.state.loading} />
                        </Button>
                    </ControlGroup>
                </fieldset>
            </form>;
        }
        else {
            formElements = <form onSubmit={this.handleReset.bind(this)}>
                <fieldset>
                    <h4 className='text-success'>Message Sent</h4>
                    <button
                        style={{paddingLeft: 0}}
                        type="submit"
                        className='btn btn-link'>

                        Send Another
                    </button>
                </fieldset>
            </form>;
        }

        return (
            <section>
                <h3 className="orange">Send a message</h3>
                {formElements}
            </section>
        );
    }
}

export default Form;
